import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BackButton, TableData } from "components";
import { getPDSSegmentsService } from "services/admin/productService";
import { Box, Grid } from "@mui/material";
import { errorAlert } from "helpers/alerts";
import { createBagPDSSegmentsService, deleteBagPDSSegmentsService } from "services/client/bagService";
import { setPDSSegments } from "redux/slices/admin/productSlice";
import { setPDSSegments as setBagPDSSegments } from "redux/slices/client/bagSlice";

const BagPDSSegmentScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentCommerce } = useSelector((store) => store.commerces);
  const currentBag = currentCommerce.bags.find(bag => bag.type === 'PDS');
  const { pdsSegments: bagPDSSegments } = useSelector((store) => store.bags);
  const { pdsSegments } = useSelector((state) => state.products);

  useEffect(() => {
    getPDSSegmentsService()
      .then((data) => dispatch(setPDSSegments(data)))
      .catch(error => errorAlert(error))
    // eslint-disable-next-line
  }, []);

  const handlerCheck = async ({ id }, currentValue) => {
    (currentValue ?
      deleteBagPDSSegmentsService(currentBag.id, id) :
      createBagPDSSegmentsService(currentBag.id, id)
    ).then((result) => {
      dispatch(setBagPDSSegments(result));
    }).catch(error => errorAlert(error))
  };

  return (
    <>
      <Box mt={2} />
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <BackButton click={() => navigate(-1)} />
        </div>
        <div className="container-title">
          <div className="commerce">Segmentos</div>
        </div>
        <div>
        </div>
      </Grid>
      <TableData
        dataRows={pdsSegments.map((item) => {
          const find = bagPDSSegments.find(({ idSegment }) => idSegment.id === item.id);
          return { ...item, state: find ? true : false };
        })}
        dataTitle={["Logo", "Nombre", "Estado"]}
        formatter={({ name, state, fd }) => [
          { type: "img", value: `/v3/file/${fd}/` },
          name,
          { name: "state", type: "boolean", value: state },
        ]}
        onChecked={handlerCheck}
      />
    </>
  );
};

export default BagPDSSegmentScreen;
